import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as blueprint from '@adc/blueprint';
import ScrollSpy from '../../../layouts/scrollspy';
export class WinningBidDepositBadge extends blueprint.listing.badges
    .WinningBidDepositBadge {
    get tooltipContent() {
        return (_jsx("div", { children: _jsx(ScrollSpy, { selector: '#prepare_your_finances', children: ({ scrollTo }) => (_jsxs(_Fragment, { children: ["A Winning Bid Deposit is required for each property you successfully bid on and must be paid upon being declared the winning bidder. Further action will be required to submit the remaining balance.", ' ', _jsx("a", { onClick: scrollTo, "data-elm-id": 'winning_bid_deposit_badge_tooltip-content', children: "Learn more" })] })) }) }));
    }
}
//# sourceMappingURL=winningBidDeposit.js.map